/* ChefDiem cinematic motion — one subtle, consistent choreography on homepage & cart. */
(function(){
'use strict';
function init(){
  var root=document.querySelector('[data-chefdiem-home]')||document.getElementById('ChefDiemCart');
  if(!root||root.dataset.cdCinemaLoaded)return;
  root.dataset.cdCinemaLoaded='true';
  if(!('IntersectionObserver' in window)||!('requestAnimationFrame' in window))return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var home=root.hasAttribute('data-chefdiem-home');
  var registered=new Set();
  function add(selector,type,step){
    Array.prototype.forEach.call(root.querySelectorAll(selector),function(el,i){
      if(registered.has(el))return;
      registered.add(el);
      el.setAttribute('data-cd-motion',typeof type==='function'?type(i):type);
      el.style.setProperty('--cd-delay',Math.min(i*(step||0),180)+'ms');
    });
  }
  if(home){
    add('.cd-hero__copy .cd-eyebrow','up');
    add('.cd-hero__copy h1','up');
    add('.cd-hero__copy .cd-lead','up');
    add('.cd-hero__visual','zoom');
    add('.cd-hero__offer','up');
    add('.cd-buy__copy h2','up');
    add('.cd-buy__action','up');
    add('.cd-story .cd-section-intro h2','up');
    add('.cd-story .cd-section-intro > p:last-child','up');
    add('.cd-steps > .cd-step','up',75);
    add('.cd-blades__head h2','up');
    add('.cd-blades__grid > .cd-blade-card','up',65);
    add('.cd-material__visual','zoom');
    add('.cd-material__copy','up');
    add('.cd-trust__intro h2','up');
    add('.cd-trust__cards > article','up',70);
    add('.cd-faq__grid > div:first-child h2','up');
    add('.cd-accordion > details','up',45);
    add('.cd-support__copy h2','up');
    add('.cd-support__panel','up');
    var progress=document.createElement('div');
    progress.className='cd-cinema-progress';progress.setAttribute('aria-hidden','true');
    root.appendChild(progress);
    var scheduled=false;
    function renderProgress(){
      scheduled=false;
      var y=Math.max(0,window.scrollY||0);
      var full=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
      root.style.setProperty('--cd-page-progress',Math.min(1,y/full).toFixed(4));
      root.classList.toggle('cd-cinema-scrolled',y>130);
    }
    function requestProgress(){
      if(!scheduled){scheduled=true;window.requestAnimationFrame(renderProgress);}
    }
    renderProgress();
    window.addEventListener('scroll',requestProgress,{passive:true});
    window.addEventListener('resize',requestProgress,{passive:true});
  }else{
    add('.cd-cart__heading h1','up');
    add('.cd-cart__heading p','up');
    add('.cd-cart__products','up');
    add('.cd-cart__summary','up');
  }
  if(!registered.size)return;
  var items=Array.from(registered);
  root.classList.add('cd-motion-ready');
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){entry.target.classList.add('cd-motion--in');observer.unobserve(entry.target);}
    });
  },{rootMargin:'0px 0px -5% 0px',threshold:.025});
  items.forEach(function(el){observer.observe(el)});
  // Above-the-fold content animates on the next paint. Never delay the buy action.
  var first=items.filter(function(el){
    var r=el.getBoundingClientRect();
    return r.bottom>=0&&r.top<window.innerHeight*.96;
  });
  window.requestAnimationFrame(function(){
    first.forEach(function(el){el.classList.add('cd-motion--in');observer.unobserve(el);});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
else init();
})();
